import { ErrorHandler, Injectable } from '@angular/core';

/* istanbul ignore next */
@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error(error);
  }
}
